import type { UIEvent } from 'react';

import { RectangleArrowRightIcon } from '@grupoboticario/flora-react-icons';

import { Logout } from './Header.components.styles';

type LogoutProps = {
  onClick: (event: UIEvent<HTMLButtonElement>) => void;
};

const LogoutBase = ({ onClick }: LogoutProps) => (
  <Logout.Button radius="rounded" onClick={onClick} data-testid="header-logout-button">
    Sair da conta
    <RectangleArrowRightIcon size={24} />
  </Logout.Button>
);

export default LogoutBase;
